module.exports = __webpack_public_path__ + "img/pie-chart.634197ce.svg";